import {
  setDoc,
  doc,
  getDoc,
  addDoc,
  collection,
  query,
  where,
  getDocs,
} from 'firebase/firestore';
import { db } from '@/app/firebase/config';

function useJobToFirebase() {
  const addJobToFirebase = async (JobData) => {
    try {
      if (!JobData || !JobData.basketID) {
        console.warn(
          'JobData is null or basketID is missing. Skipping Job processing.'
        );
        return null;
      }

      // Check for existing job using `basketID` stored in document data
      const jobsRef = collection(db, 'gymJobs');
      const existingJobQuery = query(
        jobsRef,
        where('basketID', '==', JobData.basketID)
      );
      const existingJobSnapshot = await getDocs(existingJobQuery);

      if (!existingJobSnapshot.empty) {
        // If a job exists with this `basketID`, update the first matching document
        const existingDoc = existingJobSnapshot.docs[0];
        const existingData = existingDoc.data();

        if (JSON.stringify(existingData) !== JSON.stringify(JobData)) {
          await setDoc(doc(db, 'gymJobs', existingDoc.id), JobData, {
            merge: true,
          });
          console.log('Job updated successfully:', existingDoc.id);
        } else {
          console.log('No changes detected. Job not updated.');
        }

        return existingDoc.id; // Return the existing document ID
      } else {
        // If no job exists, create a new document with Firestore-generated ID
        const newDocRef = await addDoc(collection(db, 'gymJobs'), JobData);
        console.log('New Job created successfully with ID:', newDocRef.id);

        return newDocRef.id; // Return the new Firestore-generated document ID
      }
    } catch (error) {
      console.error('Error adding or updating Job in Firestore:', error);
      throw error; // Re-throw the error for the calling component
    }
  };

  return addJobToFirebase;
}

export default useJobToFirebase;
